import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=3ed7008d&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=js&"
export * from "./FileIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=3ed7008d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed7008d",
  null
  
)

export default component.exports